import { InputMaskBase } from "./mask_base";
import { ITextInputParams } from "./mask_utils";

export class InputElementAdapter {
  private prevUnmaskedValue: string = undefined;
  private maskedEmptyValue : string;

  private setInputValue(value: string) {
    if (this.inputElement.maxLength >= 0 && this.inputElement.maxLength < value.length) {
      value = value.slice(0, this.inputElement.maxLength);
    }
    this.inputElement.value = value;
  }
  private updateInputValue() {
    if (!!this.inputElement.placeholder && this.inputElement.value == this.maskedEmptyValue) {
      this.inputElement.value = "";
    }
  }
  constructor(private inputMaskInstance: InputMaskBase, private inputElement: HTMLInputElement, value?: any) {
    let _value: any = value;
    if (_value === null || _value === undefined) {
      _value = "";
    }
    this.maskedEmptyValue = this.inputMaskInstance.getMaskedValue("");
    this.setInputValue(inputMaskInstance.getMaskedValueBySaveMode(_value));
    this.updateInputValue();
    this.prevUnmaskedValue = _value;

    inputMaskInstance.onPropertyChanged.add(this.inputMaskInstancePropertyChangedHandler);
    this.addInputEventListener();
  }

  inputMaskInstancePropertyChangedHandler = (sender: any, options: any) => {
    if (options.name !== "saveMaskedValue") {
      const maskedValue = this.inputMaskInstance.getMaskedValue(this.prevUnmaskedValue);
      this.setInputValue(maskedValue);
    }
  };
  public updateInputElementValue(value: any): void {
    if (value === null || value === undefined) {
      value = "";
    }
    const maskedValue = this.inputMaskInstance.getMaskedValueBySaveMode(value);
    if (this.inputElement.value !== maskedValue) {
      this.setInputValue(maskedValue);
      this.updateInputValue();
    }
    this.prevUnmaskedValue = value;
  }
  clickHandler = (event: any) => {
    if (this.inputElement.value == this.maskedEmptyValue) {
      this.inputElement.setSelectionRange(0, 0);
    }
  };

  focusHandler = (event: any) => {
    if (!!this.inputElement.placeholder && this.inputElement.value == "") {
      this.setInputValue(this.maskedEmptyValue);
    }
    this.clickHandler(event);
  };

  blurHandler = (event: any) => {
    this.updateInputValue();
  };

  beforeInputHandler = (event: any) => {
    if (this.inputElement.readOnly) {
      event.preventDefault();
      return;
    }
    const args = this.createArgs(event);
    const result = this.inputMaskInstance.processInput(args);
    this.setInputValue(result.value);
    this.inputElement.setSelectionRange(result.caretPosition, result.caretPosition);
    if (!result.cancelPreventDefault) {
      event.preventDefault();
    }
  };

  changeHandler = (event: any) => {
    const result = this.inputMaskInstance.processInput({ prevValue: "", insertedChars: event.target.value, selectionStart: 0, selectionEnd: 0 });
    this.setInputValue(result.value);
  };

  public createArgs(event: any): ITextInputParams {
    const args: ITextInputParams = {
      insertedChars: event.data,
      selectionStart: event.target.selectionStart,
      selectionEnd: event.target.selectionEnd,
      prevValue: event.target.value,
      inputDirection: "forward"
    };

    if (event.inputType === "deleteContentBackward") {
      args.inputDirection = "backward";

      if (args.selectionStart === args.selectionEnd) {
        args.selectionStart = Math.max(args.selectionStart - 1, 0);
      }
    }
    if (event.inputType === "deleteContentForward" && args.selectionStart === args.selectionEnd) {
      args.selectionEnd += 1;
    }

    return args;
  }
  public addInputEventListener(): void {
    if (!!this.inputElement) {
      this.inputElement.addEventListener("beforeinput", this.beforeInputHandler);
      this.inputElement.addEventListener("click", this.clickHandler);
      this.inputElement.addEventListener("focus", this.focusHandler);
      this.inputElement.addEventListener("blur", this.blurHandler);
      this.inputElement.addEventListener("change", this.changeHandler);
    }
  }
  public removeInputEventListener(): void {
    if (!!this.inputElement) {
      this.inputElement.removeEventListener("beforeinput", this.beforeInputHandler);
      this.inputElement.removeEventListener("click", this.clickHandler);
      this.inputElement.removeEventListener("focus", this.focusHandler);
      this.inputElement.removeEventListener("blur", this.blurHandler);
      this.inputElement.removeEventListener("change", this.changeHandler);
    }
  }
  public dispose(): void {
    this.removeInputEventListener();
    this.inputElement = undefined as any;
    this.inputMaskInstance.onPropertyChanged.remove(this.inputMaskInstancePropertyChangedHandler);
  }
}